(() => {
  const sections = document.querySelectorAll('[data-hero-fadeout="true"]');
  if (!sections.length) return;

  const ZOOM_MAX = 0.08;
  const LIFT_VH  = 6;
  const SOLID_TOGGLE_AT = 0.85; // 85%通過で色あり化

  const header = document.querySelector('header.header, .shopify-section-header-sticky, .site-header');

  function progressOf(el){
    const r = el.getBoundingClientRect();
    const h = r.height || 1;
    const p = (0 - r.top) / h; // 0〜1
    return Math.max(0, Math.min(1, p));
  }

  function applyFor(section){
    const p = progressOf(section);
    const media = section.querySelector('.hero-fadeout__media');
    const overlay = section.querySelector('.hero-overlay');

    if (media){
      media.style.opacity = String(1 - p);
      media.style.transform = `scale(${1 + ZOOM_MAX * p}) translateY(${-LIFT_VH * p}vh)`;
    }
    if (overlay){
      overlay.style.opacity = String(1 - p);
      overlay.style.transform = `translateY(${8 * p}px)`;
    }

    if (header){
      const solid = p > SOLID_TOGGLE_AT;      // 動画をほぼ通過 → 色あり
      header.classList.toggle('header--solid', solid);
      header.classList.toggle('header--transparent', !solid); // 動画領域内 → 透明
    }
  }

  let ticking = false;
  function onScroll(){
    if (!ticking){
      ticking = true;
      requestAnimationFrame(() => {
        sections.forEach(applyFor);
        ticking = false;
      });
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  sections.forEach(applyFor);
})();